import Autoplay from 'embla-carousel-autoplay';
import { usePathname } from 'next/navigation';
import { useMemo, useRef } from 'react';
import { Carousel, CarouselContent, CarouselItem } from '@/components/ui/carousel';
import MediaPreview from '@/components/ui/media-preview';
import { cn } from '@/lib/utils';
import { useGetAllBannerSets } from '@/shared/functions/tanstack-query/get/banner-sets/get-all-banner-sets/use-index';
export default function LearnMoreIntroBanner() {
  const pathName = usePathname();
  const {
    data: BannerSets,
    isLoading: isLoadingBannerSets,
    error
  } = useGetAllBannerSets({
    pageUrl: pathName,
    active: 'true'
  });
  const plugin = useRef(Autoplay({
    delay: 3000,
    stopOnInteraction: true
  }));
  const renderMedias = useMemo(() => {
    if (!BannerSets?.data.length) return null;
    return BannerSets.data.map(banner_set => {
      if (!banner_set.medias) return null;
      return banner_set.medias.map(media => {
        return <CarouselItem key={media.id} className={cn('relative mx-auto p-0 flex md:h-[900px] h-[700px] shrink-0 grow basis-full overflow-hidden rounded-none ')}>
						<MediaPreview media={media} className="rounded-none object-cover aspect-video" />
					</CarouselItem>;
      });
    });
  }, [BannerSets]);
  if (isLoadingBannerSets || error || !BannerSets?.data.length) return null;
  return <Carousel className="mx-auto w-full p-0" plugins={[plugin.current]} opts={{
    slidesToScroll: 'auto',
    containScroll: 'trimSnaps',
    loop: true
  }}>
			<CarouselContent className="m-0 size-full items-center rounded-none">{renderMedias}</CarouselContent>
		</Carousel>;
}